import { render, staticRenderFns } from "./GenerateJigFormSection.vue?vue&type=template&id=667528a0"
import script from "./GenerateJigFormSection.vue?vue&type=script&lang=ts"
export * from "./GenerateJigFormSection.vue?vue&type=script&lang=ts"
import style0 from "./GenerateJigFormSection.vue?vue&type=style&index=0&id=667528a0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports